import React, { useRef, useState, useEffect } from "react";
import { toPng } from "html-to-image";
import TicketSalon from "./TicketSalon";
import Ticket from "./Ticket";
import Entrada from "./Entrada";
import "../CSS/Prueba.css";

export default function Prueba(props) {
  const {
    salon,
    nombre,
    fecha,
    nombreParticipante,
    asientos,
    id,
    idTicket,
    fechaCompra,
    comidas,
    nroTicket,
    tipoEvento,
    lugar,
  } = props;
  const [imageUrl, setImageUrl] = useState(null);
  const containerRef = useRef(null);
  const containerRefSalonPC = useRef(null);
  const containerRefSalonMobile = useRef(null);

  const [tablesSeats, setTablesSeats] = useState([]);
  const [asientosString, setAsientosString] = useState("");
  const [esCelular, setEsCelular] = useState(true);
  const [datosCargados, setDatosCargados] = useState(true); // MOSTRAR BARRA DE CARGA

  function groupTablesSeats() {
    const mesas = {};
    asientos
      .split(",")
      .sort()
      .forEach((asiento) => {
        const numeroMesa = asiento.slice(0, -1);
        const letraAsiento = asiento.slice(-1);
        if (!mesas[numeroMesa]) {
          mesas[numeroMesa] = [];
        }

        mesas[numeroMesa].push(letraAsiento);
      });
    setTablesSeats(mesas);
  }
  const handleConvert = () => {
    //console.log("es celular ? " + esCelular);
    if (lugar == "Salon de eventos") {
      toPng(containerRefSalonPC.current)
        .then(function (dataUrl) {
          setImageUrl(dataUrl);
        })
        .catch(function (error) {
          //console.error("Oops, algo salió mal!", error);
        });
    } else {
      toPng(containerRef.current)
        .then(function (dataUrl) {
          setImageUrl(dataUrl);
        })
        .catch(function (error) {
          //console.error("Oops, algo salió mal!", error);
        });
    }
  };
  const handleDownload = () => {
    handleConvert();
    new Promise((res) => setTimeout(res, 2000));

    const downloadLink = document.createElement("a");
    downloadLink.href = imageUrl;
    downloadLink.download = nombre + " " + nombreParticipante;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  useEffect(() => {
    handleConvert();
  }, [asientosString]);
  useEffect(() => {
    handleConvert();
  }, [nombre]);
  useEffect(() => {
    handleConvert();
    console.log("es celular? " + esCelular);
  }, [esCelular]);
  useEffect(() => {
    if (asientos) groupTablesSeats();
    handleConvert();
  }, [asientos]);
  useEffect(() => {
    //console.log(tablesSeats);
    if (tablesSeats) {
      let resultado = "";
      Object.entries(tablesSeats).map(
        ([numeroMesa, letraAsiento]) =>
          (resultado =
            resultado +
            `Mesa ${numeroMesa} (${letraAsiento.sort().join(",")}) \n `)
      );
      //console.log(resultado);
      if (resultado) {
        const final = resultado.toString();
        let otrofiltro = final;
        setAsientosString(otrofiltro);
      }
    }
    handleConvert();
  }, [tablesSeats]);
  useEffect(() => {
    const esCelular = /Mobi|Android/i.test(navigator.userAgent);
    setEsCelular(esCelular);
    console.log("gola");
    setDatosCargados(false);
  }, []);
  return (
    <div className="congrats">
      <h1 className="tituloFeli">Detalles del ticket</h1>
      <div className="ticket-card">
        {datosCargados ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "0px auto",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ verticalAlign: "middle", display: "block" }}>
              <div>
                <img
                  style={{ height: "300px" }}
                  src={require(`../img/docucargando.gif`)}
                  alt="esperando"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="ticket">
            {lugar == "Salon de eventos" ? (
              <div ref={containerRefSalonPC}>
                {esCelular ? (
                  <div>
                    <Entrada
                      salon={salon}
                      nombre={nombre}
                      fecha={fecha}
                      nombreParticipante={nombreParticipante}
                      asientos={asientos}
                      id={id}
                      idTicket={idTicket}
                      fechaCompra={fechaCompra}
                      comidas={comidas}
                      nroTicket={nroTicket}
                      asientosString={asientosString}
                      handleConvert={handleConvert}
                      lugar={lugar}
                      tipoEvento={tipoEvento}
                    />
                  </div>
                ) : (
                  <div>
                    <TicketSalon
                      salon={salon}
                      nombre={nombre}
                      fecha={fecha}
                      nombreParticipante={nombreParticipante}
                      asientos={asientos}
                      id={id}
                      idTicket={idTicket}
                      fechaCompra={fechaCompra}
                      comidas={comidas}
                      nroTicket={nroTicket}
                      asientosString={asientosString}
                      handleConvert={handleConvert}
                      lugar={lugar}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div ref={containerRef}>
                {esCelular ? (
                  <Entrada
                    salon={salon}
                    nombre={nombre}
                    fecha={fecha}
                    nombreParticipante={nombreParticipante}
                    asientos={asientos}
                    id={id}
                    idTicket={idTicket}
                    fechaCompra={fechaCompra}
                    comidas={comidas}
                    nroTicket={nroTicket}
                    asientosString={asientos}
                    handleConvert={handleConvert}
                    tipoEvento={tipoEvento}
                    lugar={lugar}
                  />
                ) : (
                  <Ticket
                    salon={salon}
                    nombre={nombre}
                    fecha={fecha}
                    nombreParticipante={nombreParticipante}
                    asientos={asientos}
                    id={id}
                    idTicket={idTicket}
                    fechaCompra={fechaCompra}
                    comidas={comidas}
                    nroTicket={nroTicket}
                    handleConvert={handleConvert}
                    tipoEvento={tipoEvento}
                    lugar={lugar}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>
      <div style={{ paddingBottom: "3em", textAlign: "center" }}>
        <div className="boton-contenedor">
          <button className="boton" onClick={handleDownload}>
            Descargar ticket
          </button>
        </div>
        <h1 style={{ color: "red" }}>
          Descargue e imprima el ticket para presentarlo el día del evento.
        </h1>
        <h1 style={{ color: "blue" }}>
          Nota: No podra moverse del los asiento seleccionados.
        </h1>
      </div>
    </div>
  );
}
